import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";

interface ArtworkHeaderProps {
  title: string;
  secondaryTitleLines?: string[];
  registrationNumber: string;
  t: (key: string) => string;
}

export function ArtworkHeader({
  title,
  secondaryTitleLines,
  registrationNumber,
  t,
}: ArtworkHeaderProps) {
  return (
    <div className="flex items-center justify-between subpixel-antialiased">
      <div className="flex flex-col gap-1 mb-1 w-full">
        {registrationNumber && (
          <HoverCard>
            <HoverCardTrigger className="font-semibold text-base w-fit text-black cursor-pointer">
              {registrationNumber}
            </HoverCardTrigger>
            <HoverCardContent
              className="font-semibold text-xs p-2 border-none shadow"
              side="top"
            >
              {t("singleArtworkHoverCardNumber")}
            </HoverCardContent>
          </HoverCard>
        )}
        <div className="w-full">
          <p className="font-semibold text-[28px] leading-tight w-full">{title}</p>
          {secondaryTitleLines && secondaryTitleLines.length > 0 && (
            <div className="mt-1 text-sm font-normal leading-snug">
              {secondaryTitleLines.map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
